export const NOT_FOUND_ERROR_PAGE_ROUTE = "/page-introuvable"
export const SERVER_ERROR_PAGE_ROUTE = "/page-introuvable"
export const NETWORK_ERROR_PAGE_ROUTE = "/page-introuvable"
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
export const ROLE_AGENT = "ROLE_AGENT";
export const ROLE_CAISSE = "ROLE_CAISSE";